
export const getEnv = (name, defaultValue = "") => {
  const value = import.meta.env[`VITE_${name}`];

  if (value === undefined) {
    return defaultValue;
  }

  // Handle boolean strings
  if (defaultValue === true || defaultValue === false) {
    return value === "true";
  }

  return value;
};

export const isDev = () => import.meta.env.DEV;


export const isProd = () => import.meta.env.PROD;

export default getEnv;
